/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarycheckinsbyhour4Inputs */

const en_summarycheckinsbyhour4 = /** @type {(inputs: Summarycheckinsbyhour4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-ins per hour`)
};

const de_summarycheckinsbyhour4 = /** @type {(inputs: Summarycheckinsbyhour4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-ins pro Stunde`)
};

/**
* | output |
* | --- |
* | "Check-ins per hour" |
*
* @param {Summarycheckinsbyhour4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarycheckinsbyhour4 = /** @type {((inputs?: Summarycheckinsbyhour4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarycheckinsbyhour4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarycheckinsbyhour4(inputs)
	return de_summarycheckinsbyhour4(inputs)
});
export { summarycheckinsbyhour4 as "summaryCheckInsByHour" }